import React from 'react';
import PRIVACY from '../assets/documents/privacy.pdf';
import './styles/terms.scss';

function PrivacyPolicyView() {
  return (
    <div>
      <embed className="Terms" src={PRIVACY} />
    </div>
  );
}

export default PrivacyPolicyView;
